module.exports = __webpack_public_path__ + "img/radix-logo-black.4f843ab9.svg";